<template>
	<!--
		Largura limitada de propósito: class "w-full" esticava o diálogo
		na horizontal inteira e deixava a caixa de mensagem visualmente estranha
		no coletor e no desktop.
	-->
	<Dialog
		ref="dialogRef"
		v-model:visible="visible"
		v-focustrap
		modal
		class="msg-dialog"
		:style="dialogStyle"
		:closable="closable"
	>
		<template v-if="title" #header>
			<span class="msg-dialog__title">
				<b>{{ title }}</b>
			</span>
		</template>
		<div class="msg-dialog__body" v-html="msg?.replace(/\n/g, '<br>')" />
		<template #footer>
			<span v-if="buttons?.length === 0">
				<R3Button severity="danger" @click="closeDialog">Fechar</R3Button>
			</span>
			<span v-for="(but, index) in buttons" v-else :key="index" class="msg-dialog__btn-wrap">
				<!-- O atributo autofocus não garante o foco, por isto usaremos o watcher -->
				<Button @click="returnButtonIndex(index)">
					{{ but }}
				</Button>
			</span>
		</template>
	</Dialog>
</template>

<script lang="ts" setup>
	import { ref, watch, nextTick, onMounted, onUnmounted } from 'vue';
	import type { msgDialogPropsParams } from "~/types/components/DMODU_CONTROLE/msgDialog.types";
	import R3Button from "../R3/Button/R3Button.vue";

	const emits = defineEmits("ok-button-click");

	const { handleResponse, msg, buttons, title, closable, visible, msgtype, msgDlgShowStatus, callBackFN } = useMessageDlg();
	const props = defineProps<Partial<msgDialogPropsParams>>();
	const showMsgDialog = defineModel<boolean>("show");

	// Adiciona o ref para o Dialog
	const dialogRef = useTemplateRef("dialogRef");

	/**
	 * Caixa de mensagem compacta (estilo MsgBox / MessageDlg).
	 * - min(92vw, 22rem): cabe no coletor com margem lateral, sem esticar no desktop.
	 * Inline style porque o Dialog do PrimeVue teleporta para o body e classes scoped não pegam.
	 */
	const dialogStyle = {
		width: "min(92vw, 22rem)",
		maxWidth: "22rem",
	};



	function returnButtonIndex(index: number) {
		handleResponse(index);
	}

	// Função para focar no primeiro botão
	async function focusFirstButton() {
		// Aguarda a atualização do DOM
		await nextTick();

		// Busca o primeiro botão no footer do dialog
		const firstButton = document.querySelector('.p-dialog-footer .p-button');
		if (firstButton instanceof HTMLElement) {
			firstButton.focus();
		}
	}

	watch(visible, async (newVal) => {
		if (newVal) {
			await focusFirstButton();
		}
	});





	onMounted(() => {
		//console.log("visível msgDlg", visible.value);
		// Se o dialog já estiver visível no momento da montagem, foca no primeiro botão
		if (visible.value) {
			focusFirstButton();
		}
	});

	// watch(visible, (newVal) => {
	// 	if (newVal === false) {
	// 		if (callBackFN.value) {
	// 			callBackFN.value();
	// 		}
	// 	}
	// });

	onUnmounted(() => {

	});

	function closeDialog() {
		msgDlgShowStatus.value = "closed";
		showMsgDialog.value = false;
	}

	function showMessage() {
		alert("message");
	}

	defineExpose({ showMessage });
</script>

<style scoped>
	pre {
		white-space: pre-line;
	}
</style>

<!--
	Estilos globais do seletor .msg-dialog: o Dialog teleporta para body,
	então :deep/scoped não alcançam o painel. Classe própria evita afetar outros Dialogs.
-->
<style>
	.msg-dialog.p-dialog {
		width: min(92vw, 22rem) !important;
		max-width: 22rem !important;
	}

	/* Delphi MessageDlg: título e texto centralizados no card */
	.msg-dialog .p-dialog-header {
		padding: 0.85rem 1rem 0.5rem;
		justify-content: center;
		text-align: center;
	}

	.msg-dialog .msg-dialog__title {
		font-size: 1.05rem;
		line-height: 1.3;
		word-break: break-word;
		display: block;
		width: 100%;
		text-align: center;
	}

	.msg-dialog .p-dialog-content {
		padding: 0.5rem 1rem 0.75rem;
		text-align: center;
	}

	.msg-dialog .msg-dialog__body {
		font-size: 0.95rem;
		line-height: 1.45;
		word-break: break-word;
		overflow-wrap: anywhere;
		text-align: center;
		/* quebras \n → <br> ficam no meio do card, como no MsgDlg Delphi */
		margin: 0 auto;
	}

	.msg-dialog .p-dialog-footer {
		padding: 0.5rem 1rem 0.85rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 0.5rem;
	}

	.msg-dialog .msg-dialog__btn-wrap {
		display: inline-flex;
	}
</style>